module.exports = __webpack_public_path__ + "img/smile_742751.0469271b.png";